import settings from "./settings";

const homeMeta = {
  keywords: ' software development companies, software development company, it solutions custom software development Dubai, custom software development UAE, custom software development Abu Dhabi, customised software, custom software development agency,software development UAE, custom software development services company, software development custom software development, visitor management solution, visitor management system, visitor management software, visitor management system for office, guest management software, visitor system, office visitor management system, guest registration software, visitor management system kiosk, visitor management kiosk systems, kiosk based visitor management system, visitor management system mobile app, data center monitoring, environmental monitoring system, server room environmental monitoring, data center environmental monitoring, meeting room solutions, meeting room manager, meeting room system, conference room booking system, conference room reservation system, meeting room reservation system, conference room system, meeting room conference system, boardroom solutions, conference hall booking system, best file sharing for small business, file sharing solutions for small business, file sharing software for business, best file sharing software for business https://www.majtech.ae/services/customized-software/ تطوير برمجيات مخصصة  شركة تطوير برمجيات مخصصةبرمجيات مخصصةوكالةتطوير برمجيات مخصصة شركة خدمات تطوير برمجيات مخصصةتطوير برمجيات\n' +
    '\n' +
    'نظام إدارة الزوار\n' +
    'برنامج إدارة الزوار\n' +
    'نظام إدارة الزوار للمكاتب\n' +
    'برنامج إدارة الضيوف\n' +
    'نظام الزوار\n' +
    'نظام إدارة زوار المكاتب\n' +
    'برنامج تسجيل الضيوف\n' +
    'نظام إدارة الزوار عبر الأكشاك\n' +
    'أنظمة أكشاك إدارة الزوار\n' +
    'نظام إدارة الزوار عبر الأكشاك\n' +
    'تطبيق جوال لنظام إدارة الزوار\n' +
    '\n' +
    'مراقبة مركز البيانات\n' +
    'نظام مراقبة البيئة\n' +
    'مراقبة بيئة غرفة الخادم\n' +
    'مراقبة بيئة مركز البيانات\n' +
    '\n' +
    'حلول غرف الاجتماعات\n' +
    'مدير غرفة الاجتماعات\n' +
    'نظام غرف الاجتماعات\n' +
    'نظام حجز غرف المؤتمرات\n' +
    'نظام حجز غرف المؤتمرات\n' +
    'نظام غرف الاجتماعات\n' +
    'نظام مؤتمرات غرف الاجتماعات\n' +
    'حلول غرف الاجتماعات\n' +
    'نظام حجز قاعات المؤتمرات\n' +
    '\n' +
    'أفضل مشاركة ملفات للشركات الصغيرة\n' +
    'حلول مشاركة ملفات للشركات الصغيرة\n' +
    'برنامج مشاركة ملفات للشركات\n' +
    'أفضل برنامج مشاركة ملفات',
  canonical: settings.domain,
  title: 'MAJ Technology Software Development Company, IT, Solutions, Mobile App Development Company, Customized Software Development Company, SMS, Temperature, Environment, Data Center, Data Centre, Server Room, AKCP, EVOKO, Call, Email, Alert, Notification, Meeting Room, Board Meeting, Paperless, Visitor Management Software, VMS, File sharing and collaboration, AMC, Abudhabi | MAJ Technology Dubai UAE GCC  customised software development, custom software development company, customised software, custom software development agency, custom software development services company, software development custom software development, visitor management system, visitor management software, visitor management system for office, guest management software, visitor system, office visitor management system, guest registration software, visitor management system kiosk, visitor management kiosk systems, kiosk based visitor management system, visitor management system mobile app, data center monitoring, environmental monitoring system, server room environmental monitoring, data center environmental monitoring, meeting room solutions, meeting room manager, meeting room system, conference room booking system, conference room reservation system, meeting room reservation system, conference room system, meeting room conference system, boardroom solutions, conference hall booking system, best file sharing for small business, file sharing solutions for small business, file sharing software for business, best file sharing software for business\n',
  description: 'MAJ Technology L.L.C is a leading Technology and Software Solutions Provider with years of expertise in providing cost effective and customized software solutions to various clients in the United Arab Emirates and in the GCC.',
  robots: 'index follow',
  googleSiteVerification: '-IiUP11Q_MHPo-fb9cBQO861DS2x3Fx-OOAiw7CAKkw',
}

const aboutMeta = {
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/about',
  title: 'About Us - MAJ Technology',
  description: 'Learn more about MAJ Technology, a leading Technology and Software Solutions Provider in the UAE and GCC, specializing in customized software solutions.',
  robots: 'index follow',
}

const webApplicationDevelopment = {
  title: 'Web Application Development Dubai UAE | MAJ Technology',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/services/web-application-development',
  description: 'As the technology advances and the programming landscape changes to accomodate the worlds growing technological needs, MAJ Technology constantly evaluates the latest trends in the development community. We improve ourselves to provide our clients the best possible development solutions.',
  robots: 'index follow',
}

const mobileApplicationDevelopment = {
  title: 'Mobile Application Development Dubai UAE | MAJ Technology',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/services/mobile-development',
  description: 'Mobile application development is the process of creating software apps that run on mobile devices like smartphones and tablets. These apps are designed to provide seamless performance, engaging user experiences, and access to device features like cameras, GPS, and notifications. Developers typically build mobile apps',
  robots: 'index follow',
}

const customSoftwareMeta = {
  title: 'Custom Software Development Dubai UAE | MAJ Technology',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/services/customized-software',
  description: `${homeMeta.description} Custom Software Development Dubai UAE customized-software`,
  robots: 'index follow',
}

const erpSoftware = {
  title: 'ERP Software Development Dubai UAE | MAJ Technology',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/services/erp-solutions',
  description: `${homeMeta.description} ERP Software Development Dubai UAE erp-solutions`,
  robots: 'index follow',
}

const contactMeta = {
  title: 'Contact | MAJ Technology',
  keywords: homeMeta.keywords,
  canonical: settings.domain+'/careers',
  description: `Contact at MAJ Technology ${homeMeta.description}`,
  robots: 'index follow',
}

export {
  homeMeta,
  aboutMeta,
  webApplicationDevelopment,
  mobileApplicationDevelopment,
  customSoftwareMeta,
  erpSoftware,
  contactMeta
}